import { render, staticRenderFns } from "./DeleteContentDialog.vue?vue&type=template&id=de7bf9f2&scoped=true"
import script from "./DeleteContentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteContentDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DeleteContentDialog.vue?vue&type=style&index=0&id=de7bf9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7bf9f2",
  null
  
)

export default component.exports